import { vars } from "../css/vars.css";

export const lightColors = vars.colors;

export const darkColors = vars.colors;
